
































import _ from "lodash";
import rest from "@/rest";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
// component
// interfaces
const globals = namespace("globals");
const ux = namespace("ux");

@Component({
  components: {
  },
})
export default class TopicSheet2 extends Vue {
  @Prop() title!: string;
  @Prop() text!: string;
  @Prop() icon!: string;
  @Prop() altText!: string;
  // @Prop() noImage!: boolean;
  @Prop() size!: string; // 24, evtl.: x-small, small, medium, large, x-large
  @Prop() color!: string;
  @Prop() weight!: string; // lighter, normal, bold, bolder, 100,200,300,400,500,600,700,800,900
  @Prop() fontStyle!: string; // normal, italic, oblique

  @ux.State darkTheme: any;
  // @ux.Getter gradientBackground: any;
  // @ux.Getter gradientBackground2: any;
  // @ux.Getter gradientBackground3: any;
  // @ux.Getter gradientText: any;

  // $refs!: {};

  mounted() {}

  get transparentAccent() {
    return this.color ? this.color + "30" : this.$store.state.ux.colorAccent + "30";
  }

  get headLineStyle() {
    let lineStyle = "";
    if (this.$vuetify.breakpoint.xsOnly) lineStyle = "text-h6";
    else lineStyle = "text-h5";

    // if (this.darkTheme)
    //   lineStyle += " gradientDarkText";
    // else
    //   lineStyle += " gradientLightText";

    return lineStyle;
  }

  get fontSize() {
    if (this.size == null) return "18px";
    if (isNaN(Number(this.size)))
      // Number(this.size) != NaN)
      return this.size;
    return this.size + "px";
  }

  get lineHeight() {
    let fs = this.fontSize.replace("px", "");
    if (isNaN(Number(fs))) return this.fontSize;

    return Number(fs) + 2 + "px";
  }
}
